import { SUSPENSION_STATUS } from "redux/stomp/stompSubscriptionSlice";
import {
  CommonPageResponse,
  CommonResponse,
  LEVEL_TYPE,
} from "./commonInterface.interface";
import {
  RestrictedRecorder,
  SubscriptionInfo,
} from "./recorderInterface.interface";
import { BILLING_CYCLE, DISCOUNT_TIER } from "./subscription.interface";
import {
  UserGroupRecorderPermission,
  UserGroupUserPermission,
} from "./userInterface.interface";
import { BILLING_TYPE } from "./planInterface.interface";

export enum TEMPORARY_ACCESS_STATUS {
  NO = "NO", // 요청안함
  REQ = "REQ", // 요청 중인 상태 (승인 전)
  ACC = "ACC", // 승인완료
}

export interface linkAccountInfo {
  accountId: string;
  accountName: string;
}

export interface AccountInfo extends PricingRequest {
  accountId: string;
  parentId?: string;
  parentLevel: LEVEL_TYPE;
  accountAdditionalNumber: string;
  name: string;
  level: LEVEL_TYPE;
  accountNumber: string;
  timezone: string; // @todo: enum
  dateFormat: string; // @todo: enum
  timeFormat: string; // @todo: enum
  use2faAuth: boolean;
  hasAccounts: number;
  hasRecorders: number;
  hasCameras: number;
  hasUsers: number;
  companyName: string;
  companyLocation: string;
  companyLogo: string;
  description: string;
  parentAccount: linkAccountInfo[];
  isFavorite: boolean;
  ownerId?: string;
  ownerName?: string;
  ownerEmail?: string;
  isSuspended: number;
  cascadedSuspension: number;
  isActive?: boolean;
  createdAt: string;
  enableTransfer?: boolean;
  enableEdit: boolean;
  billingType: BILLING_TYPE;
  billingPeriod?: BILLING_CYCLE;
  isPayment: boolean;
  planAutoEnroll?: boolean;
  subscriptionInfo?: SubscriptionInfo;
}

export interface GetAccountListResponse extends CommonPageResponse {
  result: AccountInfo[];
}

export interface CUDAccountResponse extends CommonResponse {
  result: AccountInfo;
}

export interface AccountAccessCheckRequest {
  accountId: string;
  email: string;
}

export interface AccountAccessCheckResponse extends CommonResponse {
  result: {
    hidden: boolean;
    member: boolean;
  };
}

export interface SuspendedPayload {
  suspensionStatus: number;
  accountId: string;
  targetAccountId: string;
}

export interface TransferRequest {
  originalAccountId: string;
  targetAccountId: string;
  dstAccountNumber: string;
}

export interface TransferResponse extends CommonResponse {
  result?: string;
}

export interface UpdateAccountRequest extends PricingRequest {
  accountId?: string;
  parentId: string;
  name: string;
  level: LEVEL_TYPE;
  parentLevel: string;
  accountNumber: string;
  timezone: string;
  dateFormat: string;
  timeFormat: string;
  accountAdditionalNumber: string;
  use2faAuth: boolean;
  inviteEmail?: string;
  inviteName?: string;
  description: string;
  billingType: BILLING_TYPE;
}

export type CreateAccountRequest = UpdateAccountRequest;

export interface getAccoountNumberRequest {
  parentId: string;
  parentLevel: string;
  parentAccountNumber: string;
  number: string;
}

export interface getAccoountNumberResponse extends CommonResponse {
  result: getAccoountNumberRequest;
}

export interface getAccuntOwnersReponse extends CommonResponse {
  result: {
    id: string;
    name: string;
    email: string;
    phone?: string;
  }[];
}

export interface ProfileAccountInfoFromServer extends PricingRequest {
  accountId: string;
  accountName: string;
  accountLevel: LEVEL_TYPE;
  accountNumber: string;
  accountAdditionalNumber: string;
  parentAccountId: string;
  parentLevel: string;
  timezone: string;
  dateFormat: string;
  timeFormat: string;
  companyName: string;
  companyLocation: string;
  companyLogo: string;
  use2faAuth: boolean;
  userPermission: UserGroupUserPermission[];
  recorderPermission: UserGroupRecorderPermission[];
  description: string;
  isTrial?: boolean;
  isHidden: boolean;
  isSuspended: number;
  licenseType?: string;
  trialDays?: number;
  parentAccount?: linkAccountInfo[];
  totalAccount?: number;
  isFavorite: boolean;
  isCreator: boolean;
  createdAt: string;
  invitedOwner: boolean;
  creatorName?: string;
  creatorEmail?: string;
  isDecide: number;
  ownerEmail?: string;
  subscriptionInfo?: SubscriptionInfo;
  cascadedSuspension: number;
  restrictList: RestrictedRecorder[];
  isTemporaryAccess: TEMPORARY_ACCESS_STATUS;
  temporaryAccessDuration: number;
  billingType: BILLING_TYPE;
  isPayment: boolean; // CP 일 때는 결제여부 / EU 일 때는 Usage 구독상태
  cycle: BILLING_CYCLE;
  planActiveChannel: number;
  planActiveDate?: string;
}

export interface ProfileAccountInfo
  extends Omit<ProfileAccountInfoFromServer, "userPermission" | "isSuspended"> {
  userPermission: UserGroupUserPermission;
  isAdminGroup: boolean;
  checkedUserAdmin: boolean;
  channelIsPreparing?: boolean;
  storageIsPreparing?: boolean;
  ownerId?: string;
  ownerName?: string;
  ownerEmail?: string;
  name?: string;
  isEnabled: boolean;
  isSuspended: SUSPENSION_STATUS;
  isOnlyCustomUser: boolean;
  isUsagePaid: boolean;
  accountLevelExtendSubCp: LEVEL_TYPE;
}

export interface DecideRequest {
  accountId: string;
  isDecide: number;
}

export interface DecideResponse extends CommonResponse {
  result?: {
    isDecide: number;
  };
}

export interface PricingRequest {
  discountTier: DISCOUNT_TIER;
  discount?: number;
  creditLimit?: number;
}

export interface AdminUserResult {
  email: string;
  isOwner: boolean;
}

export interface GetAdminUserResponse extends CommonResponse {
  result: AdminUserResult[];
}
